import { Link } from "react-router-dom";

export function ForbiddenPage() {
  return (
    <div className="container min-vh-100 d-flex align-items-center justify-content-center">
      <div className="text-center">
        <h1 className="display-6">403 - Access Denied</h1>
        <p className="text-muted">You do not have permission to view this page.</p>
        <Link to="/admin/dashboard" className="btn btn-dark">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
